import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComandaService } from '../../../services/comanda.service';
import { RestaurantTableService } from '../../../services/restaurantTable.service';
import { Comanda, ComandaStatus } from '../../../models/comanda.model';
import { RestaurantTable } from '../../../models/restaurantTable.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    TableModule,
    PaginatorModule,
    DropdownModule,
    TagModule,
    TooltipModule,
  ],
  selector: 'app-list-comanda',
  templateUrl: './list-comanda.component.html',
  styleUrls: ['./list-comanda.component.css'],
})
export class ListComandaComponent implements OnInit {
  comandas: Comanda[] = [];
  tables: RestaurantTable[] = [];
  loading = true;
  totalRecords = 0;
  first = 0;
  rows = 5;
  currentPage = 1;
  statusFilter: string = '';
  mesaIdFilter: number | null = null;
  statusOptions = [
    { label: 'Todos', value: '' },
    { label: 'Aberta', value: 'ABERTA' },
    { label: 'Fechada', value: 'FECHADA' },
    { label: 'Cancelada', value: 'CANCELADA' },
  ];
  mesaOptions: { label: string; value: number | null }[] = [{ label: 'Todas as mesas', value: null }];

  constructor(
    private comandaService: ComandaService,
    private restaurantTableService: RestaurantTableService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.loadTables();
    this.loadComandas();
  }

  loadTables(): void {
    this.restaurantTableService.list(undefined, 1).subscribe({
      next: (response) => {
        const list = Array.isArray(response.data) ? response.data : [];
        this.tables = list;
        this.mesaOptions = [
          { label: 'Todas as mesas', value: null },
          ...list.map(t => ({ label: `Mesa ${t.number}`, value: t.id })),
        ];
      },
    });
  }

  loadComandas(): void {
    this.loading = true;
    const status = this.statusFilter ? (this.statusFilter as ComandaStatus) : undefined;
    const mesaId = this.mesaIdFilter ?? undefined;
    this.comandaService.list(status, mesaId, this.currentPage).subscribe({
      next: (response) => {
        this.comandas = Array.isArray(response.data) ? response.data : [];
        this.totalRecords = response.pagination?.totalRecords ?? 0;
        this.first = (this.currentPage - 1) * this.rows;
        this.loading = false;
      },
      error: () => {
        this.comandas = [];
        this.totalRecords = 0;
        this.loading = false;
      },
    });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.first = 0;
    this.loadComandas();
  }

  view(comanda: Comanda): void {
    this.router.navigate(['/app/restaurant/comandas/view', comanda.id]);
  }

  fechar(comanda: Comanda): void {
    if (comanda.status !== 'ABERTA') return;
    if (!confirm('Fechar esta comanda? As mesas vinculadas serão liberadas.')) return;
    this.comandaService.fechar(comanda.id).subscribe({
      next: () => this.loadComandas(),
      error: () => alert('Erro ao fechar comanda.'),
    });
  }

  cancelar(comanda: Comanda): void {
    if (comanda.status !== 'ABERTA') return;
    if (!confirm('Cancelar esta comanda? As mesas vinculadas serão liberadas.')) return;
    this.comandaService.cancelar(comanda.id).subscribe({
      next: () => this.loadComandas(),
      error: () => alert('Erro ao cancelar comanda.'),
    });
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.rows = event.rows ?? this.rows;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.loadComandas();
  }

  getStatusSeverity(status: string): string {
    switch (status) {
      case 'ABERTA': return 'success';
      case 'FECHADA': return 'secondary';
      case 'CANCELADA': return 'danger';
      default: return 'secondary';
    }
  }

  getStatusLabel(status: string): string {
    const opt = this.statusOptions.find(o => o.value === status);
    return opt?.label ?? status;
  }

  formatDate(value: string | null | undefined): string {
    if (!value) return '—';
    try {
      const d = new Date(value);
      return isNaN(d.getTime()) ? value : d.toLocaleString('pt-BR');
    } catch {
      return value;
    }
  }

  getTablesDisplay(tables: Comanda['tables'] | undefined): string {
    if (!tables?.length) return '—';
    return tables.map(t => t.number).join(', ');
  }
}
